module.exports = {
      id: "newsletter-usage",
      viewBox: "0 0 26 23.012",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#newsletter",
      toString: function () {
        return this.url;
      }
    }